export const REGIONS = [
  {
    id: 'NL',
    value: 'Netherlands',
  },
  {
    id: 'HU',
    value: 'Hungary',
  },
  {
    id: 'PL',
    value: 'Poland',
  },
  {
    id: 'UA',
    value: 'Ukraine',
  },
  {
    id: 'BE',
    value: 'Belgium',
  },
  {
    id: 'DE',
    value: 'Germany',
  },
];
